// extracted by mini-css-extract-plugin
export default {"header":"ReportsHeader_header__eevHe","navigation":"ReportsHeader_navigation__aV1oe","title":"ReportsHeader_title__uHYfH"};